<template>
    <div>
        <div class="mb-4">
            <div v-if="region.name === 'Centro-Oeste'">
                <p>
                    O Brasil tem muitas vozes, jeitos e trejeitos que formam um povo plural. Cada
                    cantinho do país tem seus causos, suas lendas, seus sotaques que deixam qualquer
                    conversa mais gostosa. No <strong> Centro-Oeste</strong> brasileiro não é
                    diferente, lá se pode encontrar tantas histórias que mal cabem nesse texto e é
                    por isso que a gente resolveu dar lugar à voz. Nosso podcast celebra toda essa
                    diversidade que vira história e que faz história. Eu já vou me encerrar por aqui
                    que é pra você dar o play e conhecer nosso
                    <strong>podcast</strong>
                </p>
            </div>
            <div v-if="region.name === 'Nordeste'">
                <p>
                    “Não sei, só sei que foi assim!” História boa é aquela que, ao ser contada, faz
                    morada, gera identificação ou te transporta para um outro lugar. A
                    <strong>Chico</strong> é feita de mais histórias do que se pode contar e a gente
                    gosta de compartilhá-las em todo lugar, seja em uma estampa ou em um
                    <strong>podcast</strong>. Sabemos que boas histórias têm o poder de eternizar,
                    transformar tristeza em riso e servir de acalanto. Do
                    <strong>Nordeste</strong> pro mundo, tem muito causo bom pra ser contado por aí,
                    então aumenta o volume e vem fazer essa viagem com a gente.
                </p>
            </div>
            <div v-if="region.name === 'Norte'">
                <p>
                    Ao nosso redor tem muita beleza esperando para ser descoberta. Se a gente parar
                    pra observar a sensibilidade e o encanto de crença dos
                    <strong>povos indígenas</strong>, aprendemos a ser um com a terra a qual
                    pertencemos. É no respeito, na entrega e na fé que a gente embarca nessa viagem
                    interior. Reconhecer o que nos permite ser e o que foi antes de nós não é apenas
                    um agradecimento ao tempo, é uma forma de construir terreno para a vida que
                    ainda virá! A gente deu uma volta grande mas necessária pra falar que nesse
                    espaço a gente conta algumas <strong>histórias</strong> do
                    <strong>Norte</strong>, dessa vez, por meio da palavra falada.
                </p>
            </div>
            <div v-if="region.name === 'Sudeste'">
                <p>
                    A palavra falada tem o poder de envolver, de tocar o outro apenas com a voz e
                    fazer borbulhar milhares de sentimentos. É que a história quando dita de
                    múltiplas formas, cria uma sensação de intimidade, sabe? O nosso
                    <strong>podcast</strong> abre as portas e dá boas-vindas para toda essa fala
                    cheia de cultura, poesia e caso pra contar. O <strong>Sudeste</strong> é casa de
                    muita gente e cê já sabe, todo mundo tem uma opinião pra dar, por isso a gente
                    reuniu um punhado dessas muitas vozes para dar vida ao nosso
                    <srong>podcast</srong>
                    .
                </p>
            </div>
            <div v-if="region.name === 'Sul'">
                <p>
                    <srong>Bah!</srong>
                    Se tem uma coisa que a gente gosta de fazer é contar caso. Sabe quando você
                    reúne aqueles amigos de longa data e tira o dia só pra prosear? Então, nós
                    amamos. Somos conversadores compulsivos e se tiver uma boa
                    <strong>história</strong> no meio fica melhor ainda. Foi por conta disso que
                    criamos o <strong>podcast da Chico</strong>, um espaço para conversar, rir e
                    conhecer um pouco mais sobre a cultura do nosso <strong>Brasil</strong>. A gente
                    ouviu falar que as terras <strong>sulistas</strong> têm muita coisa pra contar e
                    resolvemos compartilhar tudo isso com você
                </p>
            </div>
        </div>
        <div v-if="podcasts">
            <CountryRegionPodcast
                v-for="(podcast, index) in podcasts"
                :key="index"
                :class="{ mt: index > 0 }"
                :item="podcast"
            />
        </div>
    </div>
</template>

<script>
    import CountryRegionPodcast from './CountryRegionPodcast';

    export default {
        name: 'CountryRegionPodcasts',

        components: { CountryRegionPodcast },

        props: {
            region: {
                type: Object,
                required: true,
            },
        },

        computed: {
            podcasts() {
                return this.region.resources.data.filter(
                    (r) => r.url.indexOf('https://open.spotify') === 0
                );
            },
        },
    };
</script>